import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import MobileStickyBar from '../components/common/MobileStickyBar';
import MoodboardBlock from '../components/common/MoodboardBlock';
import { ArrowRight, Sparkles } from 'lucide-react';

const UNIVERS_SHOWROOM = [
  {
    type: 'mariage',
    label: '💍 Mariage',
    hero: 'https://images.unsplash.com/photo-1767986012138-d02276728368?w=800&q=80',
    color: '#D4AF37',
  },
  {
    type: 'anniversaire_adulte',
    label: '🎉 Anniversaire Adulte',
    hero: 'https://images.unsplash.com/photo-1748551204321-845c277c1dba?w=800&q=80',
    color: '#F4A7B2',
  },
  {
    type: 'anniversaire_enfant',
    label: '🎈 Anniversaire Enfant',
    hero: 'https://images.unsplash.com/photo-1765947378663-9e7ad34ca310?w=800&q=80',
    color: '#5DBCBF',
  },
  {
    type: 'entreprise',
    label: '💼 Entreprise & CE',
    hero: 'https://images.unsplash.com/photo-1756885465373-bce82fd5c944?w=800&q=80',
    color: '#5DBCBF',
  },
];

// Galerie réalisations
const REALISATIONS = [
  { img: 'https://images.unsplash.com/photo-1581720848209-9721f8fa30ff?w=600&q=80', label: 'Mariage élégant', type: 'Mariage' },
  { img: 'https://images.unsplash.com/photo-1765947378663-9e7ad34ca310?w=600&q=80', label: 'Anniversaire coloré', type: 'Anniversaire' },
  { img: 'https://images.unsplash.com/photo-1748551204321-845c277c1dba?w=600&q=80', label: 'Soirée adulte', type: 'Anniversaire adulte' },
  { img: 'https://images.unsplash.com/photo-1768508948485-a7adc1f3427f?w=600&q=80', label: 'Cocktail entreprise', type: 'Entreprise' },
  { img: 'https://images.unsplash.com/photo-1581745073351-e053d7d73694?w=600&q=80', label: 'Décoration mariage', type: 'Mariage' },
  { img: 'https://images.unsplash.com/photo-1765947377925-941c12c84331?w=600&q=80', label: 'Fête enfants', type: 'Anniversaire' },
  { img: 'https://images.unsplash.com/photo-1756885465373-bce82fd5c944?w=600&q=80', label: 'Séminaire pro', type: 'Entreprise' },
  { img: 'https://images.unsplash.com/photo-1731743215053-53eb81151f60?w=600&q=80', label: 'Baptême familial', type: 'Baptême' },
  { img: 'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62?w=600&q=80', label: 'Garden party', type: 'Fête' },
];

export default function ShowroomPage() {
  const [activeUnivers, setActiveUnivers] = useState('mariage');
  const [filtreGalerie, setFiltreGalerie] = useState('all');

  const filteredRealisations = filtreGalerie === 'all'
    ? REALISATIONS
    : REALISATIONS.filter(r => r.type.toLowerCase().includes(filtreGalerie.toLowerCase()));

  return (
    <div style={{ background: 'var(--bg)', minHeight: '100vh' }}>
      <Header />

      {/* HERO SHOWROOM */}
      <section style={{ background: 'linear-gradient(135deg, #0B1E20 0%, #1a3a3c 100%)', borderBottom: '3px solid #D4AF37' }}>
        <div className="container-ose section-py text-center">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Sparkles size={20} style={{ color: '#D4AF37' }} />
            <span className="text-xs font-bold uppercase tracking-widest" style={{ color: '#D4AF37' }}>
              Showroom Événementiel
            </span>
          </div>
          <h1 className="font-display text-3xl sm:text-5xl font-bold mb-4"
            style={{ color: '#FFFFFF', letterSpacing: '-0.03em', lineHeight: '1.1' }}>
            Inspirations & Réalisations<br />
            <span style={{ color: '#D4AF37' }}>Show Événement</span>
          </h1>
          <p className="text-sm mb-8 max-w-xl mx-auto" style={{ color: 'rgba(255,255,255,0.65)', lineHeight: '1.75' }}>
            Explorez nos univers événementiels, découvrez les tendances 2026 et composez votre événement idéal.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/creer-evenement"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl font-bold text-sm"
              style={{ background: '#D4AF37', color: '#0B1E20', boxShadow: '0 10px 30px rgba(212,175,55,0.35)' }}>
              Créer mon événement <ArrowRight size={16} />
            </Link>
            <Link to="/guides"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl font-semibold text-sm"
              style={{ border: '1px solid rgba(255,255,255,0.25)', color: '#FFFFFF' }}>
              📚 Voir les guides
            </Link>
          </div>
        </div>
      </section>

      {/* UNIVERS MOODBOARDS */}
      <section className="section-py section-white">
        <div className="container-ose">
          <div className="text-center mb-8">
            <h2 className="font-display text-2xl sm:text-3xl font-bold" style={{ color: 'var(--ink)', letterSpacing: '-0.02em' }}>
              Univers & Inspirations
            </h2>
            <p className="text-sm mt-2" style={{ color: 'var(--text-muted)' }}>Choisissez votre univers pour découvrir les inspirations 2026</p>
          </div>

          {/* Onglets univers */}
          <div className="flex flex-wrap justify-center gap-2 mb-8">
            {UNIVERS_SHOWROOM.map(u => (
              <button key={u.type}
                onClick={() => setActiveUnivers(u.type)}
                className="px-5 py-2.5 rounded-xl text-sm font-semibold transition-all"
                style={{
                  background: activeUnivers === u.type ? '#0B1E20' : '#FFFFFF',
                  color: activeUnivers === u.type ? '#D4AF37' : 'var(--text-muted)',
                  border: `1.5px solid ${activeUnivers === u.type ? '#D4AF37' : 'var(--border)'}`,
                  cursor: 'pointer',
                }}>
                {u.label}
              </button>
            ))}
          </div>

          {/* Moodboard actif */}
          <div className="max-w-2xl mx-auto">
            <MoodboardBlock eventType={activeUnivers} />
          </div>
        </div>
      </section>

      {/* GALERIE RÉALISATIONS */}
      <section className="section-py" style={{ background: 'var(--bg)' }}>
        <div className="container-ose">
          <div className="text-center mb-8">
            <h2 className="font-display text-2xl sm:text-3xl font-bold" style={{ color: 'var(--ink)', letterSpacing: '-0.02em' }}>
              Nos réalisations
            </h2>
            <p className="text-sm mt-2" style={{ color: 'var(--text-muted)' }}>Événements organisés avec Show Événement dans le Lot, l'Aveyron et le Cantal</p>
          </div>

          {/* Filtres */}
          <div className="flex flex-wrap justify-center gap-2 mb-6">
            {['all', 'Mariage', 'Anniversaire', 'Entreprise', 'Baptême', 'Fête'].map(f => (
              <button key={f}
                onClick={() => setFiltreGalerie(f === 'all' ? 'all' : f)}
                className="px-3 py-1.5 rounded-xl text-xs font-semibold"
                style={{
                  background: filtreGalerie === f || (f === 'all' && filtreGalerie === 'all') ? '#D4AF37' : 'var(--bg)',
                  color: filtreGalerie === f || (f === 'all' && filtreGalerie === 'all') ? '#0B1E20' : 'var(--text-muted)',
                  border: '1px solid var(--border)',
                  cursor: 'pointer',
                }}>
                {f === 'all' ? 'Tous' : f}
              </button>
            ))}
          </div>

          {/* Grille galerie masonry-like */}
          <div className="columns-2 sm:columns-3 gap-3 space-y-3">
            {filteredRealisations.map((r, i) => (
              <div key={i} className="break-inside-avoid overflow-hidden rounded-2xl group relative">
                <img src={r.img} alt={r.label}
                  className="w-full object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{ minHeight: i % 3 === 0 ? '200px' : '150px' }}
                  loading="lazy" />
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end"
                  style={{ background: 'linear-gradient(0deg, rgba(11,30,32,0.7) 0%, transparent 50%)' }}>
                  <div className="p-3">
                    <p className="font-bold text-sm" style={{ color: '#FFFFFF' }}>{r.label}</p>
                    <span className="text-xs px-2 py-0.5 rounded-full font-semibold"
                      style={{ background: 'rgba(212,175,55,0.3)', color: '#D4AF37' }}>{r.type}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="section-py" style={{ background: '#0B1E20' }}>
        <div className="container-ose text-center">
          <h2 className="font-display text-2xl sm:text-3xl font-bold mb-4" style={{ color: '#FFFFFF' }}>
            Votre événement mérite la même attention
          </h2>
          <p className="text-sm mb-8 max-w-lg mx-auto" style={{ color: 'rgba(255,255,255,0.6)' }}>
            Devis gratuit en 2 minutes. Disponibles 24h/24 pendant votre événement. Rayon 1h30 autour de Figeac.
          </p>
          <Link to="/creer-evenement"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-bold text-base"
            style={{ background: '#D4AF37', color: '#0B1E20', boxShadow: '0 12px 40px rgba(212,175,55,0.35)' }}>
            Créer mon devis gratuit <ArrowRight size={18} />
          </Link>
        </div>
      </section>

      <Footer />
      <MobileStickyBar />
    </div>
  );
}
